import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'draft-js/dist/Draft.css';
import { FormattedMessage, useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Tooltip from '@mui/material/Tooltip';
import ToggleButton from '@mui/material/ToggleButton';

import useGlobalStatus from '../../hook/useGlobalStatus';
import useColorSystem from '../../hook/useColorSystem';

import { BoxBorderGrey, CustomFormLabel } from '../customComponent';
import * as urlConstants from '../../constants/url';
import { DescriptionOutlinedIcon, EqualizerIcon } from '../../constants/images';
import theme from '../../theme';

const checkExcelSelected = (currentData, originalData) => {
  return currentData.includes(originalData) ? true : false;
}

const ExcelData = (props) => {
  const {
    media,
    excelSheets,
    excelSheetSelected,
    setExcelSheetSelected,
    setSelectedOptionFields,
    inputErrorMsg,
    downloadInputErrorMsg,
  } = props;

  const intl = useIntl();
  const { currentActiveData, entryPath, locale } = useGlobalStatus();
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  useEffect(() => {
    if (entryPath.includes('create')) {
      const defaultTab = excelSheets.filter((el) => el.selected).map((item) => item.original_name);
      setExcelSheetSelected(defaultTab);
    }
    if (entryPath.includes('edit')) {
      setExcelSheetSelected(currentActiveData.excelSheets);
    }
  }, [entryPath, currentActiveData])

  const changeExcelPage = (e, graphic_name) => {
    const { name, checked } = e.target;

    setExcelSheetSelected(prev => {
      const newSet = new Set(prev);
      if (checked) {
        newSet.add(name);
      } else {
        newSet.delete(name);
        newSet.delete(graphic_name);
      }
      return Array.from(newSet);
    })

    if (media === 'TABOOLA') {
      setSelectedOptionFields(prev => prev.map(field => {
        const sheetArray = Array.isArray(field.sheet) ? field.sheet : [];
        const newSheet = new Set(sheetArray);
        checked ? newSheet.add(name) : newSheet.delete(name);

        return { ...field, sheet: Array.from(newSheet) }
      })
      )
    }
  }

  const changeExcelGraphic = (e, sheet) => {
    if (excelSheetSelected.includes(sheet.graphic_name)) {
      setExcelSheetSelected(prev => prev.filter(el => el !== sheet.graphic_name));
    } else {
      setExcelSheetSelected(prev => [...prev, sheet.graphic_name]);
    }
  }

  return (
    <Box mb={5}>
      <Typography
        sx={{
          ...theme.typography.h4_normal,
          mb: 2,
          color: theme.palette.grey.w700,
        }}
      >
        <DescriptionOutlinedIcon
          sx={{
            mr: 0.5,
            verticalAlign: 'sub'
          }}
        />
        <FormattedMessage id="createData.header.setTab" />
      </Typography>

      <Box mb={2}>
        <CustomFormLabel>
          <FormattedMessage id="createData.header.tab" /><span>*</span>
        </CustomFormLabel>
        <BoxBorderGrey
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            p: 1
          }}
        >
          {excelSheets
            .filter(item => item.original_name !== 'RAW_DATA')
            .map((el, index) => {
              return (
                <BoxBorderGrey
                  key={el.original_name}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: locale.includes('ja') ? '30%' : '20%',
                    border: 0,
                    mb: '4px',
                    p: '0 0 0 8px',
                    ':hover': {
                      backgroundColor: theme.palette.grey.w50
                    }
                  }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        name={el.original_name}
                        defaultChecked={
                          entryPath.includes('edit')
                            ? currentActiveData.excelSheets.includes(el.original_name)
                            : el.selected
                        }
                        disabled={el.original_name === 'RAW_DATA'}
                        onChange={(e) => changeExcelPage(e, el.graphic_name)}
                        color={colorMedia}
                      />
                    }
                    label={<FormattedMessage id={el.name} />}
                  />
                  {/* Facebook 成效圖 */}
                  {media === 'FACEBOOK' && el.graphic_name !== null &&
                    <Tooltip
                      title={
                        el.name === 'facebook.sheet.daily' ? (
                          <>
                            <FormattedMessage id={el.name} />
                            <FormattedMessage id="createData.tab.dailyChartTip" />
                          </>
                        ) : (
                          <>
                            <FormattedMessage id={el.name} />
                            <FormattedMessage id="createData.tab.chart" />
                          </>
                        )
                      }
                      placement="right"
                    >
                      <span>
                        <ToggleButton
                          color={colorMedia}
                          value={el.graphic_name}
                          selected={checkExcelSelected(excelSheetSelected, el.graphic_name)}
                          onChange={(e) => changeExcelGraphic(e, el)}
                          disabled={excelSheetSelected.includes(el.original_name) ? false : true}
                          sx={{
                            border: 'none',
                            color: theme.palette.grey.w400,
                            "&:disabled": {
                              border: 'none'
                            }
                          }}
                        >
                          <EqualizerIcon />
                        </ToggleButton>
                      </span>
                    </Tooltip>
                  }
                </BoxBorderGrey>
              )
            })
          }
        </BoxBorderGrey>
        {
          <FormHelperText error>
            {inputErrorMsg.excelSheet}
            {downloadInputErrorMsg.excelSheet}
          </FormHelperText>
        }
      </Box>
    </Box>
  )
}

export default ExcelData;